<template>
  <div class="row mx-auto my-2 py-4">
    <div class="col-md-4 p-0 mx-auto">
      <component is="qrMaker" :loading="loading" :svg="data.svg"></component>
      <v-btn class="btn-download" @click="showDialog = true">
        <v-icon>mdi-progress-download</v-icon>
        {{ $t("download_qr") }}      </v-btn>

      <!--                <qr-generator></qr-generator>-->
    </div>
    <div class="col-md mx-auto p-3">
      <v-stepper v-model="e6" class="px-0 mx-0" flat vertical>
        <v-stepper-step :complete="e6 > 1" class="px-0 px-md-4" step="1">
          <div class="row justify-center">
            <div class="col-md-12">
              <p>ورود اطلاعات</p>
              <div v-if="e6 === 1">
                <v-switch v-model="qrType" disabled>
                  <template v-slot:label>
                    <span class="text-muted"> کیوآر داینامیک باشد</span>
                    <p class="text-danger ml-2">به زودی</p>
                  </template>
                </v-switch>
              </div>
            </div>
            <div v-if="qrType" class="col-md-6 mt-0 pt-0">
              <v-text-field
                v-model="visitName"
                :disabled="e6 > 1"
                append-icon="mdi-pen"
                class="mt-0 pt-0"
                clear-icon="mdi-close-circle-outline"
                clearable
                dense
                label="نام کیوآر"
                outlined
              />
            </div>
            <div v-if="qrType" class="col-md-6 mt-0 pt-0">
              <qr-address-field
                v-model="dtUrl"
                :disabled="e6 > 1"
                append-icon="mdi-web"
                class="mt-0 pt-0"
                dense
                hint="!برای استفاده از آدرس پیشفرض، خالی بگذارید"
                outlined
                persistent-hint
              />
            </div>
          </div>
        </v-stepper-step>

        <v-stepper-content class="pr-1 mx-0 mr-md-7 px-md-4" step="1">
          <list-expansion icon="wifi" single title="wifi">
            <template v-slot:content>
              <template>
                <div class="row mx-auto">
                  <div class="col-md-4">
                    <v-autocomplete
                      v-model="data.network"
                      :items="networks"
                      append-icon="mdi-network"
                      dense
                      item-text="name"
                      item-value="value"
                      label="نوع شبکه:"
                      outlined
                    >
                    </v-autocomplete>
                  </div>
                  <div class="col-md-4">
                    <v-text-field
                      v-model="data.networkName"
                      append-icon="mdi-network"
                      counter="50"
                      dense
                      hint="لطفا نام شبکه خود را وارد کنید."
                      label="نام شبکه "
                      maxLength="50"
                      outlined
                    />
                  </div>
                  <div class="col-md-4">
                    <v-text-field
                      v-model="data.pass"
                      append-icon="mdi-key"
                      counter="50"
                      dense
                      hint="لطفا رمز عبور خود را وارد کنید."
                      label="رمز عبور "
                      maxLength="50"
                      outlined
                    />
                  </div>
                </div>
              </template>
            </template>
          </list-expansion>

          <div class="col-md-12">
            <next-btn
              :loading="loading"
              style="background: #1b8d39"
              @click="preview"
            />
          </div>
        </v-stepper-content>

        <v-stepper-step
          v-if="qrType"
          :complete="e6 > 2"
          class="px-0 px-md-4"
          step="2"
          >تنظیمات کیوآر</v-stepper-step
        >

        <v-stepper-content
          v-if="qrType"
          class="pr-1 mx-0 mr-md-7 px-md-4"
          step="2"
        >
          <qr-management :data="data" />
          <div class="row mx-auto">
            <div class="col-md-6">
              <button class="cta" style="background: red" @click="e6 = 1">
                <span class="span">بازگشت</span>
                <span class="second">
                  <svg
                    height="20px"
                    version="1.1"
                    viewBox="0 0 66 43"
                    width="30px"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                  >
                    <g
                      id="arrow"
                      fill="none"
                      fill-rule="evenodd"
                      stroke="none"
                      stroke-width="1"
                    >
                      <path
                        class="one"
                        d="M40.1543933,3.89485454 L43.9763149,0.139296592 C44.1708311,-0.0518420739 44.4826329,-0.0518571125 44.6771675,0.139262789 L65.6916134,20.7848311 C66.0855801,21.1718824 66.0911863,21.8050225 65.704135,22.1989893 C65.7000188,22.2031791 65.6958657,22.2073326 65.6916762,22.2114492 L44.677098,42.8607841 C44.4825957,43.0519059 44.1708242,43.0519358 43.9762853,42.8608513 L40.1545186,39.1069479 C39.9575152,38.9134427 39.9546793,38.5968729 40.1481845,38.3998695 C40.1502893,38.3977268 40.1524132,38.395603 40.1545562,38.3934985 L56.9937789,21.8567812 C57.1908028,21.6632968 57.193672,21.3467273 57.0001876,21.1497035 C56.9980647,21.1475418 56.9959223,21.1453995 56.9937605,21.1432767 L40.1545208,4.60825197 C39.9574869,4.41477773 39.9546013,4.09820839 40.1480756,3.90117456 C40.1501626,3.89904911 40.1522686,3.89694235 40.1543933,3.89485454 Z"
                        fill="#FFFFFF"
                      ></path>
                      <path
                        class="two"
                        d="M20.1543933,3.89485454 L23.9763149,0.139296592 C24.1708311,-0.0518420739 24.4826329,-0.0518571125 24.6771675,0.139262789 L45.6916134,20.7848311 C46.0855801,21.1718824 46.0911863,21.8050225 45.704135,22.1989893 C45.7000188,22.2031791 45.6958657,22.2073326 45.6916762,22.2114492 L24.677098,42.8607841 C24.4825957,43.0519059 24.1708242,43.0519358 23.9762853,42.8608513 L20.1545186,39.1069479 C19.9575152,38.9134427 19.9546793,38.5968729 20.1481845,38.3998695 C20.1502893,38.3977268 20.1524132,38.395603 20.1545562,38.3934985 L36.9937789,21.8567812 C37.1908028,21.6632968 37.193672,21.3467273 37.0001876,21.1497035 C36.9980647,21.1475418 36.9959223,21.1453995 36.9937605,21.1432767 L20.1545208,4.60825197 C19.9574869,4.41477773 19.9546013,4.09820839 20.1480756,3.90117456 C20.1501626,3.89904911 20.1522686,3.89694235 20.1543933,3.89485454 Z"
                        fill="#FFFFFF"
                      ></path>
                      <path
                        class="three"
                        d="M0.154393339,3.89485454 L3.97631488,0.139296592 C4.17083111,-0.0518420739 4.48263286,-0.0518571125 4.67716753,0.139262789 L25.6916134,20.7848311 C26.0855801,21.1718824 26.0911863,21.8050225 25.704135,22.1989893 C25.7000188,22.2031791 25.6958657,22.2073326 25.6916762,22.2114492 L4.67709797,42.8607841 C4.48259567,43.0519059 4.17082418,43.0519358 3.97628526,42.8608513 L0.154518591,39.1069479 C-0.0424848215,38.9134427 -0.0453206733,38.5968729 0.148184538,38.3998695 C0.150289256,38.3977268 0.152413239,38.395603 0.154556228,38.3934985 L16.9937789,21.8567812 C17.1908028,21.6632968 17.193672,21.3467273 17.0001876,21.1497035 C16.9980647,21.1475418 16.9959223,21.1453995 16.9937605,21.1432767 L0.15452076,4.60825197 C-0.0425130651,4.41477773 -0.0453986756,4.09820839 0.148075568,3.90117456 C0.150162624,3.89904911 0.152268631,3.89694235 0.154393339,3.89485454 Z"
                        fill="#FFFFFF"
                      ></path>
                    </g>
                  </svg>
                </span>
              </button>
            </div>
            <div class="col-md-6">
              <button
                class="cta float-left"
                style="background: #1b8d39"
                @click="e6 = 3"
              >
                <span class="span"> بعدی</span>
                <span class="backed" style="transform: rotate(180deg)">
                  <svg
                    height="20px"
                    version="1.1"
                    viewBox="0 0 66 43"
                    width="30px"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                  >
                    <g
                      id="arrow"
                      fill="none"
                      fill-rule="evenodd"
                      stroke="none"
                      stroke-width="1"
                    >
                      <path
                        class="one"
                        d="M40.1543933,3.89485454 L43.9763149,0.139296592 C44.1708311,-0.0518420739 44.4826329,-0.0518571125 44.6771675,0.139262789 L65.6916134,20.7848311 C66.0855801,21.1718824 66.0911863,21.8050225 65.704135,22.1989893 C65.7000188,22.2031791 65.6958657,22.2073326 65.6916762,22.2114492 L44.677098,42.8607841 C44.4825957,43.0519059 44.1708242,43.0519358 43.9762853,42.8608513 L40.1545186,39.1069479 C39.9575152,38.9134427 39.9546793,38.5968729 40.1481845,38.3998695 C40.1502893,38.3977268 40.1524132,38.395603 40.1545562,38.3934985 L56.9937789,21.8567812 C57.1908028,21.6632968 57.193672,21.3467273 57.0001876,21.1497035 C56.9980647,21.1475418 56.9959223,21.1453995 56.9937605,21.1432767 L40.1545208,4.60825197 C39.9574869,4.41477773 39.9546013,4.09820839 40.1480756,3.90117456 C40.1501626,3.89904911 40.1522686,3.89694235 40.1543933,3.89485454 Z"
                        fill="#FFFFFF"
                      ></path>
                      <path
                        class="two"
                        d="M20.1543933,3.89485454 L23.9763149,0.139296592 C24.1708311,-0.0518420739 24.4826329,-0.0518571125 24.6771675,0.139262789 L45.6916134,20.7848311 C46.0855801,21.1718824 46.0911863,21.8050225 45.704135,22.1989893 C45.7000188,22.2031791 45.6958657,22.2073326 45.6916762,22.2114492 L24.677098,42.8607841 C24.4825957,43.0519059 24.1708242,43.0519358 23.9762853,42.8608513 L20.1545186,39.1069479 C19.9575152,38.9134427 19.9546793,38.5968729 20.1481845,38.3998695 C20.1502893,38.3977268 20.1524132,38.395603 20.1545562,38.3934985 L36.9937789,21.8567812 C37.1908028,21.6632968 37.193672,21.3467273 37.0001876,21.1497035 C36.9980647,21.1475418 36.9959223,21.1453995 36.9937605,21.1432767 L20.1545208,4.60825197 C19.9574869,4.41477773 19.9546013,4.09820839 20.1480756,3.90117456 C20.1501626,3.89904911 20.1522686,3.89694235 20.1543933,3.89485454 Z"
                        fill="#FFFFFF"
                      ></path>
                      <path
                        class="three"
                        d="M0.154393339,3.89485454 L3.97631488,0.139296592 C4.17083111,-0.0518420739 4.48263286,-0.0518571125 4.67716753,0.139262789 L25.6916134,20.7848311 C26.0855801,21.1718824 26.0911863,21.8050225 25.704135,22.1989893 C25.7000188,22.2031791 25.6958657,22.2073326 25.6916762,22.2114492 L4.67709797,42.8607841 C4.48259567,43.0519059 4.17082418,43.0519358 3.97628526,42.8608513 L0.154518591,39.1069479 C-0.0424848215,38.9134427 -0.0453206733,38.5968729 0.148184538,38.3998695 C0.150289256,38.3977268 0.152413239,38.395603 0.154556228,38.3934985 L16.9937789,21.8567812 C17.1908028,21.6632968 17.193672,21.3467273 17.0001876,21.1497035 C16.9980647,21.1475418 16.9959223,21.1453995 16.9937605,21.1432767 L0.15452076,4.60825197 C-0.0425130651,4.41477773 -0.0453986756,4.09820839 0.148075568,3.90117456 C0.150162624,3.89904911 0.152268631,3.89694235 0.154393339,3.89485454 Z"
                        fill="#FFFFFF"
                      ></path>
                    </g>
                  </svg>
                </span>
              </button>
            </div>
          </div>
        </v-stepper-content>

        <v-stepper-step
          :complete="qrType ? e6 > 3 : e6 > 2"
          :step="qrType ? 3 : 2"
          class="px-0 px-md-4"
        >
          دیزاین کیوآر
        </v-stepper-step>

        <v-stepper-content
          :step="qrType ? 3 : 2"
          class="pr-1 mx-0 mr-md-7 px-md-4"
        >
          <qr-customize v-model="qrDesign" />
          <div class="row mx-auto">
            <div class="col-md-12 d-flex w-100 justify-space-between">
              <v-btn
                v-if="data.svg"
                class="btn-download ma-0 mr-auto"
                @click="showDialog = true"
              >
                <v-icon>mdi-progress-download</v-icon>
                {{ $t("download_qr") }}              </v-btn>
            </div>
          </div>
        </v-stepper-content>
      </v-stepper>

      <custom-popup
        v-model="showDialog"
        :cons="cons"
        hide-confirm
        max-width="900"
        transition="dialog-bottom-transition"
      >
        <template v-slot:helpinfo>
          <help-info
            :element-name="`${serviceName}-${componentName}-download-Qr`"
            :service-name="serviceName"
            :help-data="helpData"
            class="buttoninfo"
            label="دانلود کیوآر"
          />
        </template>
        <v-card class="px-5">
          <download-file v-if="showDialog" :svg="data.svg" />
        </v-card>
      </custom-popup>
    </div>
  </div>
</template>

<script>
import QrGenerator from "./qrGenerator";
import qrMaker from "./qrMaker";
import { debounce } from "@/main";
import DownloadFile from "../downloadFile";
import QrManagement from "@/view/pages/qrland/components/qrManage/qrManagement";
import QrAddressField from "@/view/content/fragments/qrAddressField";
import ListExpansion from "@/view/content/fragments/listExpansion";
import QrCustomize from "@/view/pages/qrland/components/qrCustomize";
import NextBtn from "@/view/content/fragments/nextBtn";

export default {
  name: "qrWifi",
  components: {
    NextBtn,
    QrCustomize,
    ListExpansion,
    QrAddressField,
    QrManagement,
    DownloadFile,
    QrGenerator,
    qrMaker,
  },
  data() {
    return {
      cons: { title: "دانلود کیوآر" },
      showDialog: false,
      qrDesign: {},
      networks: [
        { name: "WEP", value: "WEP" },
        { name: "WPA/WPA2", value: "WPA" },
      ],
      data: {
        network: "WEP",
        networkName: "",
        pass: "",
        svg: "",
        shortLink: "",
      },
      loading: false,
      visitName: "wifi",
      qrType: false,
      dtUrl: null,
      e6: 1,
    };
  },
  methods: {
    markQr() {
      this.loading = true;
      this.$api
        .post("/Qr", {
          type: "Wifi",
          format: "svg",
          encryption: this.data.network,
          ssid: this.data.networkName,
          password: this.data.pass,
          qrType: this.qrType ? "dynamic" : "static",
          size: 248,
          margin: 0,
          visitName: this.visitName,
          shorten: true,
        })
        .then((res) => {
          this.loading = false;
          this.data.svg = this.qrType ? res.data.data.svg : res.data.data.data;
          this.$toast.success("کد کیوآر شما با موفقیت ساخته شد.");
          this.data.shortLink = res.data.data.url;
        })
        .catch((err) => {
          this.loading = false;
          this.$toast.error("خطای سرور!");
        })
        .finally(() => {
          this.loading = false;
        });
    },
    preview() {
      this.loading = true;
      this.$api
        .post("/v1/Qr/preview", {
          section: "#wifi",
          ssid: this.data.networkName,
          networktype: this.data.network,
          wifipass: this.data.pass,
          backcolor: !this.qrDesign.qrStyleColors?.backcolor
            ? "#ffffff"
            : this.qrDesign.qrStyleColors?.backcolor,
          gradient_color: !this.qrDesign.qrStyleColors?.gradient_color
            ? "#8900d5"
            : this.qrDesign.qrStyleColors?.gradient_color,
          frontcolor: !this.qrDesign.qrStyleColors?.frontColor
            ? "#000000"
            : this.qrDesign.qrStyleColors?.frontColor,
          gradient: this.qrDesign.qrStyleColors?.gradient ? "on" : undefined,
          pattern: this.qrDesign.qrStyleColors.pattern,
          marker_in: this.qrDesign.MarkerCenter.eyePattern,
          marker_in_color: this.qrDesign.MarkerCenter.main,
          markers_color: "on",
          marker: this.qrDesign.QrMarkOut.markOutPattern,
          different_markers_color:
            this.qrDesign.QrMarkOut.different_markers_color ||
            this.qrDesign.MarkerCenter.different_markers_color
              ? "on"
              : undefined,
          marker_out_color: this.qrDesign.QrMarkOut.main,
          marker_top_right_outline: this.qrDesign.QrMarkOut.topRight,
          marker_top_right_center: this.qrDesign.MarkerCenter.topRight,
          marker_bottom_left_outline: this.qrDesign.QrMarkOut.bottomLeft,
          marker_bottom_left_center: this.qrDesign.MarkerCenter.bottomLeft,
          custom_frame_color: this.qrDesign.QrFrame?.different_markers_color
            ? "on"
            : undefined,
          outer_frame: this.qrDesign.QrFrame.framePattern,
          framecolor: this.qrDesign.QrFrame.main,
          framelabel: this.qrDesign.QrFrame.text,
          optionlogo: this.qrDesign.LogoImg.logoImg,
          no_logo_bg: this.qrDesign.LogoImg.noBg ? "on" : undefined,
          "logo-size": this.qrDesign.LogoImg.logoSize,
          label_font: "AbrilFatface.svg",
          "label-text-size": "100",
          size: "248",
          level: "H",
        })
        .then((res) => {
          this.loading = false;
          this.data.svg = res.data.data;
          if (this.e6 === 1) {
            this.e6 = 2;
          }
        })
        .catch((err) => {
          this.loading = false;
          this.$toast.error("خطای سرور!");
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  watch: {
    qrDesign: {
      handler() {
        if (this.data.svg) {
          debounce(() => {
            this.preview();
          }, 2000);
        }
      },
      deep: true,
    },
  },
};
</script>

<style scoped></style>
